import React, { ReactNode } from 'react'
import TopNavigation from '../top-nav/TopNavigation'

export const AuthWrapper: React.FC<{
  header?: string
  subTitle?: string
  className?: string
  children: ReactNode
}> = ({ header, className, children, subTitle }) => {
  return (
    <div
      className="
      h-screen w-screen
      flex flex-col
      "
    >
      <TopNavigation />

      <div
        className="
        flex-1 w-full
        flex items-center justify-center
        px-4 md:px-10
        "
      >
        <div
          className={`

        ${className}
        `}
        >
          {header && (
            <p
              className={`
              ${subTitle ? '' : 'mb-10'}
              font-recoleta font-semibold
              text-4xl
              w-full text-center
              `}
            >
              {header}
            </p>
          )}
          {subTitle && (
            <p
              className="
              mb-10
              w-full text-center
              "
            >
              {subTitle}
            </p>
          )}

          {children}
        </div>
      </div>
    </div>
  )
}
